export default function Scrollbar() {
    return (
        <div className="scrollbar rounded scrollbar-thumb-gray-900 scrollbar-track-gray-100">
            <div className=""></div>
        </div>
    );
};